import React from "react";
import NewBrokerNavbar from "../../../components/dashboard-nav-and-side/NewBrokerNavbar";
import NewBrokerSidebar from "../../../components/dashboard-nav-and-side/NewBrokerSidebar";

const BrokerClientPage = () => {
	return (
		<div>
			<NewBrokerNavbar />
			<NewBrokerSidebar />
		</div>
	);
};

export default BrokerClientPage;
